import { cva } from '@/styled-system/css';

export const gleamDotRecipe = cva({
  base: {
    backgroundColor: 'Gleam.bg',
    borderRadius: 'Gleam.default',
    color: 'Gleam.text',
    display: 'inline-flex',
    flexShrink: 0,
    height: 'Gleam.height.dot',
    width: 'Gleam.width.dot',
  },
  compoundVariants: [
    {
      tone: 'info',
      onImpact: false,
      css: {
        backgroundColor: 'Gleam.info.bg',
        color: 'Gleam.info.text',
      },
    },
    {
      tone: 'info',
      onImpact: true,
      css: {
        backgroundColor: 'Gleam.onImpact.info.bg',
        color: 'Gleam.onImpact.info.text',
      },
    },
    {
      tone: 'new',
      onImpact: false,
      css: {
        backgroundColor: 'Gleam.new.bg',
        color: 'Gleam.new.text',
      },
    },
    {
      tone: 'new',
      onImpact: true,
      css: {
        backgroundColor: 'Gleam.onImpact.new.bg',
        color: 'Gleam.onImpact.new.text',
      },
    },
  ],
});
